// Validate required Auth0 configuration
const validateConfig = () => {
  const missingVars = [];

  if (!window?.env?.REACT_APP_AUTH0_DOMAIN) missingVars.push('REACT_APP_AUTH0_DOMAIN');
  if (!window?.env?.REACT_APP_AUTH0_CLIENT_ID) missingVars.push('REACT_APP_AUTH0_CLIENT_ID');
  if (!window?.env?.REACT_APP_AUTH0_AUDIENCE) missingVars.push('REACT_APP_AUTH0_AUDIENCE');

  if (missingVars.length > 0) {
    console.error('[DEBUG_LOG] Missing required Auth0 configuration:', missingVars);
    throw new Error(`Missing required Auth0 configuration: ${missingVars.join(', ')}`);
  }
};

validateConfig();

export const auth0Config = {
  domain: window?.env?.REACT_APP_AUTH0_DOMAIN!,
  clientId: window?.env?.REACT_APP_AUTH0_CLIENT_ID!,
  audience: window?.env?.REACT_APP_AUTH0_AUDIENCE!,
  redirectUri: window.location.origin,
  scope: 'openid profile offline_access',
};
